<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteArticleProduct',
    props: {
        popupDeleteArticle: {
            type: Boolean,
            default: false,
        },
        articleId: Number
    },

    watch: { 
      	popupDeleteArticle: function(newVal) {
            if(newVal == true){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف مقاله",
                    text: `مقاله حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteArticle,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteArticle', false)
        },

        deleteArticle(){
            this.$vs.loading()
            this.$emit('updatePopupDeleteArticle', false)
            let id = this.articleId
            let type = 'article'
			this.$store.dispatch('deletePost', { id, type })
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'مقاله با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>